/** @format */

const theme = {
  id: "light",
  primaryColor: "#edf2f8",
  secondaryColor: "#313bac",
  blackColor: "#030303",
  lightGrayColor: "#e4e4e4",
  grayColor: "#6b7688",
  brownColor: "#46364a",
  whiteColor: "#ffffff",

  //
  navBgColor: "#edf2f8",
  sideBgColor: "#edf2f8",
  linkColor: "#313bac",
  linkHoverColor: "#030303",
  aboutCirclesColor: "#edf2f8",
  app__whitebg: "#ffffff",
  app__primarybg: "#e4e4e4",
  app__headtext: "black",
  app__headtextspan: "#313bac",
  app__textp: "#030303",
  app__headerbadge: "#e4e4e4",
};

export default theme;
